import { Component, Input, OnInit} from '@angular/core';
import { Aviso } from 'src/app/model/Aviso';
import { DocumentoPac } from 'src/app/model/DocumentoPac';
import { PedidoLiberacaoView } from 'src/app/model/view/PedidoLiberacaoView';
import { PedidoLiberacaoService } from 'src/app/services/pedido-liberacao.service';

@Component({
  selector: 'app-informacoes-pedidos-liberacao',
  templateUrl: './informacoes-pedidos-liberacao.component.html',
  styleUrls: ['./informacoes-pedidos-liberacao.component.scss'],
  standalone: false
})
export class InformacoesPedidosLiberacaoComponent implements OnInit{

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  pedidosLiberacao: PedidoLiberacaoView[]

  comentariosPL: Aviso[]=[]

  constructor(
    private pedidoLiberacaoService: PedidoLiberacaoService) { }

  ngOnInit(): void {
    this.pedidoLiberacaoService.obterPedidosDeLiberacao(this.documentoPac.id).subscribe((response: PedidoLiberacaoView[]) => {
      this.pedidosLiberacao = response.length === 0 ? undefined : response;
    })
  }

  expandirPL(id: string){
    document.getElementById(id).classList.toggle('show')

  }
}
